import { UserCapabilities } from './dashboardTypes';

export function getUserCapabilities(profile: any): UserCapabilities {
  if (!profile) {
    return {
      canConnectAts: false,
      canAddRoles: false,
      canAddCandidates: false,
      canShareRoles: false,
      canInviteUsers: false,
    };
  }

  const isAdmin =
    profile.role === 'Admin' ||
    profile.role === 'AccountHolder' ||
    profile.role === 'admin' ||
    profile.role === 'account_holder';

  // Check if marketplace is enabled (default to true if not explicitly disabled)
  const marketplaceEnabled =
    profile.company?.settings?.features?.marketplace !== false;

  return {
    canConnectAts: isAdmin,
    canAddRoles: true, // All authenticated users can add roles
    canAddCandidates: true, // All authenticated users can add candidates
    canShareRoles: marketplaceEnabled,
    canInviteUsers: isAdmin,
  };
}
